<template>
  <div>
    <Navbar />
    <div class="top-bubbles">

      <div class="blog-area wave-bg">
        <div class="container">
          <Preloader v-if="loading" />
          <div v-else class="">
            <div class="contact-info_inner search_top_banner">
              <div class="banner-content">
                <div class="title-section">
                  <h1 class="main-title">
                    <span class="title-line text-white">Find the Perfect Tech Solution</span>
                  </h1>
                  <p class="subtitle text-center">Quickly find software products, API integrations, and AI tools that match your project needs</p>
                </div>

                <div class="search-section">
                  <div class="search-container">
                    <div class="search-input-wrapper">
                      <div class="search-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                     <input 
                      type="text" 
                      v-model="searchQuery" 
                      class="search-input" 
                      placeholder="Looking for a service? Start typing here..." 
                      @input="handleSearch"
                      @keyup.enter="handleSearch"
                      @focus="showSearchResults = true" 
                      @blur="handleBlur"
                    />
                      <button @click="handleSearch" class="search-button">
                        <span class="button-text">Search</span>
                        <div class="button-icon">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </button>
                    </div>
                    <!-- Search Results Dropdown -->
                    <div v-if="showSearchResults && filteredApps.length > 0" class="search-results-dropdown">
                      <div v-for="app in filteredApps" :key="app.slug" class="search-result-item" @click="navigateToApp(app.slug)">
                        {{ app.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="floating-elements">
                  <div class="floating-card card-1">
                    <div class="card-icon">🚀</div>
                    <span class="card-text">Fast</span>
                  </div>
                  <div class="floating-card card-2">
                    <div class="card-icon">⚡</div>
                    <span class="card-text">Efficient</span>
                  </div>
                  <div class="floating-card card-3">
                    <div class="card-icon">🎯</div>
                    <span class="card-text">Precise</span>
                  </div>
                </div> -->

                <div class="background-effects">
                  <div class="gradient-orb orb-1"></div>
                  <div class="gradient-orb orb-2"></div>
                  <div class="gradient-orb orb-3"></div>
                  <div class="mesh-grid"></div>
                </div>
              </div>
            </div>
            <!-- <div class="widget widget_meander_software_posts_thumb">
                <h3 class="widget-title">Popular Apps</h3>
                <article class="item" v-for="(data) in appDATA?.data" :key="data.id">
                  <router-link :to="/app-detail/${data?.slug}" class="thumb">
                    <span
                      class="fullimage cover"
                      :style="{ backgroundImage: 'url(' + $backendUrl + data?.screenshot_1?.url + ')' }"
                      role="img"
                    ></span>
                  </router-link>


    




                  <div class="info">
                    <h4 class="title usmall">
                      <router-link :to="/app-detail/${data?.slug}">
                        {{ data?.title }}
                      </router-link>
                    </h4>
                    <span class="date">
                      <i class="ri-calendar-2-fill"></i>{{ dateFormat(data?.updatedAt) }}
                    </span>
                  </div>
                </article>
              </div> -->
            </div>
            <div class="">
              <div class="row justify-content-center project-row">
                <!-- No Data Message -->
                <div v-if="!appDATA?.data || appDATA.data.length === 0" class="col-12 text-center">
                  <div class="container">
                    <div class="no-data-wrapper">
                      <div class="no-data-icon">
                        <i class="bi bi-search"></i>
                      </div>
                      <div class="no-data-title">No Results Found</div>
                      <div class="no-data-subtitle">We couldn’t find anything matching your search. Try using different
                        keywords.</div>
                      <a href="#" class="no-data-btn">Go Back</a>
                    </div>
                  </div>
                </div>
                <!-- Main Data -->
                <div class="col-xl-3 col-md-4" v-for="(data) in appDATA?.data" :key="data.id">
                  <div class="single-blog-post bg-change">
                      <div class="pink-top-shape"></div>
                    <div class="image border-abstract">
                      <!-- <router-link :to="/app-detail/${data?.slug}" class="d-block">
                      <img
                        style="height:250px;"
                        :src="$backendUrl + data?.screenshot_1?.url"
                        :alt="data?.screenshot_1?.alternativeText || data?.title + ' - App Screenshot' || 'App Screenshot'"
                      />
                    </router-link> -->

                      <router-link :to="`/app-detail/${data.slug}`">
                        <div class="app-images">
                          <div v-if="data.screenshot_1?.url && data.screenshot_2?.url" class="check-related">
                            <div class="phone phone-left">
                              <img :src="$backendUrl + data.screenshot_1.url"
                                :alt="data.screenshot_1?.alternativeText || data.title || data.name || 'App Screenshot 1'"
                                class="img-fluid left-img" />
                            </div>
                            <div class="phone phone-right">
                              <img :src="$backendUrl + data.screenshot_2.url"
                                :alt="data.screenshot_2?.alternativeText || data.title || data.name || 'App Screenshot 2'"
                                class="img-fluid right-img" />
                            </div>
                          </div>
                          <img v-else-if="data.screenshot_1?.url" :src="$backendUrl + data.screenshot_1.url"
                            :alt="data.screenshot_1?.alternativeText || data.title || data.name || 'data Screenshot 1'"
                            class="img-fluid" style="width:100%;height:200px;object-fit:contain;" />
                          <img v-else-if="data.screenshot_2?.url" :src="$backendUrl + data.screenshot_2.url"
                            :alt="data.screenshot_2?.alternativeText || data.title || data.name || 'data Screenshot 2'"
                            class="img-fluid" style="width:100%;height:200px;object-fit:contain;" />
                          <img v-else :src="meanderLogo" alt="Meander Software Placeholder" class="img-fluid"
                            style="width:100%;height:200px;object-fit:contain;" />
                        </div>
                      </router-link>

                    </div>
                    <div class="content">
                      <ul class="meta">
                        <!-- <li class="d-flex align-items-center ">
                        <i class="ri-time-line"></i> {{ dateFormat(data?.updatedAt) }}
                      </li> -->
                        <li class="d-flex align-items-center ">
                          <i class="ri-folder-line"></i>Category Name
                        </li>
                      </ul>
                      <h3>
                        <router-link :to="`/app-detail/${data?.slug}`">
                          {{ data?.title }}
                        </router-link>
                      </h3>
                    </div>
                    <div class="pink-bottom-bar">
                      <div class="category-buttons">
  <button class="category-button">{{data?.categorories[0]?.name}}</button>
  <!-- <button class="category-button">Business</button> -->
</div>
                    </div>
                  </div>
                </div>
                <!-- Pagination -->
                <div v-if="total > pageSize" class="col-lg-12 col-md-12">
                  <div class="pagination-area">
                    <div class="nav-links justify-content-center">
                      <!-- Previous Page -->
                      <span v-if="currentPage > 1" class="page-numbers prev cursor-pointer"
                        @click="changePage(currentPage - 1)">
                        <i class="ri-arrow-left-line"></i>
                      </span>
                      <!-- Page Numbers -->
                      <span v-for="page in totalPages" :key="page"
                        :class="['page-numbers', { current: page === currentPage }]" @click="changePage(page)">
                        {{ page }}
                      </span>
                      <!-- Next Page -->
                      <span v-if="currentPage < totalPages" class="page-numbers  cursor-pointer"
                        @click="changePage(currentPage + 1)">
                        <i class="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterStyleFour />
  <!-- </div> -->
</template>

<style>
.outer-animated-border {
  position: relative;
  padding: 3px; /* border thickness */
  border-radius: 16px;
  background: linear-gradient(270deg, #ED2775, #FF7448, #ED2775);
  background-size: 400% 400%;
  animation: animatedBorder 6s ease infinite;
  width: 100%;
  max-width: 600px;
  margin: auto;
  z-index: 1;
}

@keyframes animatedBorder {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.no-data-wrapper {
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 40px 20px;
}

.no-data-icon {
  width: 120px;
  height: 120px;
  background: linear-gradient(26.1deg, #ED2775 0%, #FF7448 100%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.no-data-icon i {
  font-size: 48px;
  color: white;
}

.no-data-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.no-data-subtitle {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 25px;
}

.no-data-btn {
  background: linear-gradient(26.1deg, #ED2775 0%, #FF7448 100%);
  border: none;
  padding: 10px 25px;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  transition: background 0.3s ease;
}

.no-data-btn:hover {
  background: linear-gradient(26.1deg, #FF7448 0%, #ED2775 100%);
}

/* Modern Search Banner Styles */
.search_top_banner {
  position: relative;
  padding: 80px 20px;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
    background: linear-gradient(247.32deg, rgb(68, 0, 178), rgb(139, 79, 235) 70.53%);
  margin-bottom: 60px;
  border-radius: 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  padding: 40px 20px 10px !important;
   width: 1050px;
    margin: 0 auto;
        z-index: 11111;
}

.banner-content {
  position: relative;
  z-index: 10;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

/* Title Section */
.title-section {
  margin-bottom: 25px;
  animation: fadeInUp 1s ease-out;
  position: relative;
  z-index: 10;
}

.main-title {
  font-size: clamp(2.5rem, 5vw, 4rem) !important;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 20px;
  color: #ffffff;
  font-size: 40px !important;
}

.title-line {
  display: block;
 /* background: linear-gradient(135deg, #ffffff 0%, #fddde6 50%, #f472b6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */

  /* For Firefox */
  /* background-clip: text;
  color: transparent;
  animation: gradientShift 3s ease-in-out infinite; */
}

.subtitle {
  font-size: 1.2rem !important;
  color: #fff;
  font-weight: 400;
  animation: fadeInUp 1s ease-out 0.2s both;
  text-align: left;
}

/* Search Section */
.search-section {
  margin-bottom: 60px;
  animation: fadeInUp 1s ease-out 0.4s both;
}

.search-container {
  max-width: 600px;
  margin: 0 auto;
  position: relative; /* Added for dropdown positioning */
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  padding: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  height: 60px;
}

.search-input-wrapper:focus-within {
  border-color: #ff9960;
  box-shadow: 0 8px 32px rgba(96, 165, 250, 0.3), 0 0 0 4px rgba(96, 165, 250, 0.1);
  transform: translateY(-2px);
}

.search-icon {
  padding: 0 20px;
  color: #fff;
  transition: color 0.3s ease;
}

.search-input-wrapper:focus-within .search-icon {
  color: #fff;
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 1.1rem;
  padding: 20px 0;
}

.search-input::placeholder {
  color: #fff;
  transition: color 0.3s ease;
}

.search-input:focus::placeholder {
  color: #fff;
}

.search-button {
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
  border: none;
  border-radius: 40px;
  padding: 13px 30px;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(96, 165, 250, 0.4);
      position: absolute;
    right: 3px;
    top: 3px;
}

.search-button:hover {
     background-color: #ED2775;
    color: #fff;
}

.search-button:active {
  transform: translateY(0);
}

.button-icon {
  transition: transform 0.3s ease;
}

.search-button:hover .button-icon {
  transform: translateX(3px);
}

/* Floating Elements */
/* .floating-elements {
  position: relative;
  height: 120px;
  margin-bottom: 40px;
}

.floating-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: 500;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: float 6s ease-in-out infinite;
}

.card-icon {
  font-size: 1.5rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.card-text {
  font-size: 0.9rem;
  opacity: 0.9;
}

.card-1 {
  top: 0;
  left: 10%;
  animation-delay: 0s;
}

.card-2 {
  top: 20px;
  right: 15%;
  animation-delay: 2s;
}

.card-3 {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 4s;
} */

/* Background Effects */
.background-effects {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.6;
  animation: orbFloat 20s ease-in-out infinite;
}

.orb-1 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #60a5fa 0%, transparent 70%);
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.orb-2 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, #a78bfa 0%, transparent 70%);
  top: 50%;
  right: -100px;
  animation-delay: 7s;
}

.orb-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, #f472b6 0%, transparent 70%);
  bottom: -125px;
  left: 50%;
  animation-delay: 14s;
}

.mesh-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 30s linear infinite;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes gradientShift {
  0%, 100% {
    filter: hue-rotate(0deg);
  }
  50% {
    filter: hue-rotate(30deg);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes orbFloat {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .search_top_banner {
    padding: 60px 20px;
  }
    .search-results-dropdown {
    max-height: 300px;
    
  }
  
  .search-input-wrapper {
    /* flex-direction: column; */
    gap: 15px;
    padding: 20px;
  }
  
  .search-button {
    /* width: 100%; */
    justify-content: center;
  }
  
  .floating-card {
    padding: 10px 15px;
  }
  
  .card-1, .card-2, .card-3 {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    transform: none;
    margin: 10px auto;
  }
  
  .floating-elements {
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
}




/* Search Results Dropdown Styles (matching Navbar) */
.search-results-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 200px;
  overflow-y: auto;
  z-index: 109999;
  margin-top: 2px;
  overflow-y: auto;
}

.search-result-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background-color: #f8f9fa;
}

.search-result-item:last-child {
  border-bottom: none;
}

/* Mobile responsive adjustments for search dropdown */


.blog-area {
  padding-top: 120px;
}

.wave-bg {
  position: relative;
  min-height: 100vh;
  background: #fff;
  /* or any base color */
  overflow: hidden;
  z-index: 0;
}

/* Top wave (normal orientation) */
.wave-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 100vh;
  background: url("data:image/svg+xml;utf8,<svg width='100%' height='500' viewBox='0 0 1200 200' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><defs><linearGradient id='grad' x1='0%' y1='0%' x2='100%' y2='0%'><stop offset='0%' stop-color='%239F5FF1'/><stop offset='50%' stop-color='%23FF54B0'/><stop offset='100%' stop-color='%23FF9F5A'/></linearGradient></defs><path d='M0,100 C300,200 900,0 1200,100 L1200,0 L0,0 Z' fill='url(%23grad)' opacity='0.9'/></svg>") repeat-x;
  background-size: cover;
  animation: waveParallaxTop 10s linear infinite;
  z-index: -1;
  pointer-events: none;
  /* No rotation for top wave */
}

/* Top wave (slower, faded) */
.wave-bg::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 100vh;
  background: url("data:image/svg+xml;utf8,<svg width='100%' height='500' viewBox='0 0 1200 200' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><defs><linearGradient id='grad' x1='0%' y1='0%' x2='100%' y2='0%'><stop offset='0%' stop-color='%239F5FF1'/><stop offset='50%' stop-color='%23FF54B0'/><stop offset='100%' stop-color='%23FF9F5A'/></linearGradient></defs><path d='M0,100 C300,200 900,0 1200,100 L1200,0 L0,0 Z' fill='url(%23grad)' opacity='0.9'/></svg>") repeat-x;
  background-size: cover;
  animation: waveParallaxTopSlow 20s linear infinite;
  opacity: 0.7;
  z-index: -2;
  /* No rotation for top wave */
}

/* Bottom wave (reverse, using new pseudo-elements) */
.wave-bg::before,
.wave-bg::after {
  /* Keep existing styles for top waves */
}

/* Add bottom waves */
.wave-bg::before,
.wave-bg::after,
.wave-bg::bottom-before,
.wave-bg::bottom-after {
  pointer-events: none;
}

/* Bottom wave (reverse orientation) */
.wave-bg::bottom-before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200%;
  height: 100vh;
  background: url("data:image/svg+xml;utf8,<svg width='100%' height='500' viewBox='0 0 1200 200' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><defs><linearGradient id='grad' x1='0%' y1='0%' x2='100%' y2='0%'><stop offset='0%' stop-color='%239F5FF1'/><stop offset='50%' stop-color='%23FF54B0'/><stop offset='100%' stop-color='%23FF9F5A'/></linearGradient></defs><path d='M0,100 C300,200 900,0 1200,100 L1200,0 L0,0 Z' fill='url(%23grad)' opacity='0.9'/></svg>") repeat-x;
  background-size: cover;
  animation: waveParallaxBottom 10s linear infinite;
  z-index: 1;
  transform: rotate(180deg);
  opacity: 1;
}

/* Bottom wave (slower, faded, reverse orientation) */
.wave-bg::bottom-after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200%;
  height: 100vh;
  background: url("data:image/svg+xml;utf8,<svg width='100%' height='500' viewBox='0 0 1200 200' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><defs><linearGradient id='grad' x1='0%' y1='0%' x2='100%' y2='0%'><stop offset='0%' stop-color='%239F5FF1'/><stop offset='50%' stop-color='%23FF54B0'/><stop offset='100%' stop-color='%23FF9F5A'/></linearGradient></defs><path d='M0,100 C300,200 900,0 1200,100 L1200,0 L0,0 Z' fill='url(%23grad)' opacity='0.9'/></svg>") repeat-x;
  background-size: cover;
  animation: waveParallaxBottomSlow 20s linear infinite;
  opacity: 0.5;
  z-index: -2;
  transform: rotate(180deg);
}

/* Keyframes for top waves (left to right) */
@keyframes waveParallaxTop {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

@keyframes waveParallaxTopSlow {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-25%);
  }
}

/* Keyframes for bottom waves (right to left, reversed) */
@keyframes waveParallaxBottom {
  from {
    transform: translateX(0) rotate(180deg);
  }

  to {
    transform: translateX(50%) rotate(180deg);
  }
}

@keyframes waveParallaxBottomSlow {
  from {
    transform: translateX(0) rotate(180deg);
  }

  to {
    transform: translateX(25%) rotate(180deg);
  }
}

/* Add bottom waves using pseudo-elements via extra HTML or with a utility class if needed.
   If you can't add ::bottom-before and ::bottom-after pseudo-elements directly,
   you may need to add extra <div class="wave-bg-bottom"></div> in your template and style them accordingly. */

/* .single-blog-post .content h3 a:hover {
  color: #fff !important;
} */

.single-blog-post .content ul li {
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
  padding: 2px 10px !important;
  width: max-content;
  gap: 6px;
  color: #fff !important;
  border-radius: 6px;
  position: fixed !important;
  top: 0;
  left: 0;
  border-radius: 10px 0 10px 0;
}

.single-blog-post .content ul li i {
  color: #fff !important;
  position: unset !important;
}

.activeclass:active {
  color: brown;
}

.bg-change {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  background: #e8dff3;

  border-radius: 12px;
  text-align: center;
  padding: 40px 30px;
  min-height: 429px;
}
.bg-change .image {
  overflow: unset !important;
}

.border-abstract {
  border-bottom: 1px solid #eee;
  border-radius: 100px;
  box-shadow: rgb(17 17 26 / 7%) 0px 1px 0px;
  z-index: 11;
}

.widget-area .widget_meander_software_posts_thumb .item {
  border-bottom: 1px solid rgba(242, 60, 105, 0.19);
  padding-bottom: 10px;
}
.single-blog-post {
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
}

/* .single-blog-post:hover {
  box-shadow: 0 8px 24px rgb(0 0 0 / 0.2);
} */
@media (max-width: 575px) {
  .pink-bottom-bar {
    bottom: 0 !important;
  }
  .pink-top-shape {
    top: 0 !important;
  }
}
/* Top pink shape */
.pink-top-shape {
  position: absolute;
  top: -190px; /* hide above */
  left: 0;
  width: 100%;
  height: 190px;
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
  border-bottom-left-radius: 100% 50px;
  border-bottom-right-radius: 100% 50px;
  transition: top 0.5s ease;
  z-index: 2;
}
.category-buttons {
  display: flex;
  gap: 10px;
  padding: 10px 0;
}

.category-button {
  background-color: transparent;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;

}

 


/* Bottom pink bar */
.pink-bottom-bar {
  position: absolute;
  bottom: -50px; /* hide below */
  left: 0;
  width: 100%;
  height: 50px;
      background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);

  display: flex;
  justify-content: center;
  align-items: center;
  transition: bottom 0.4s ease;
  z-index: 2;
}

/* Social icons inside bottom bar */

 
.latest-apps-section {
  background: #fff;
 
}

.pink-bottom-bar .social-icons li a {
  color: white;
  font-size: 16px;
  transition: color 0.3s ease;
}

.pink-bottom-bar .social-icons li a:hover {
  color: #ffc1e3; /* lighter pink */
}

/* Hover effect to slide in shapes */
.single-blog-post:hover .pink-top-shape {
  top: 0;
}

.single-blog-post:hover .pink-bottom-bar {
  bottom: 0;
}

/* Content adjustments */
.content h3 a {
  color: #e91e63; /* pink color for "Web Developer" text */
  font-weight: 600;
  text-decoration: none;
}

.content h3 a:hover {
  text-decoration: underline;
}



.single-blog-post h3 {
  min-height: 60px;
}

/* .single-blog-post:hover::after {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  z-index: -1;
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
  border-radius: 14px;
 match .box + 2px padding 
}

.single-blog-post:hover {
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
} */

.single-app-card {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  transition: box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  background: linear-gradient(279.99deg, #9F5FF196 -1.19%, #FF54B042 50.99%, #FF9F5A69 100%);
  text-align: center;
}


.single-app-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
}

.check-related {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;
}

.check-related img {
  height: 220px !important;
}

.phone {
  width: 160px;
  position: relative;
}

.phone img {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.phone-left {
  z-index: 1;
  margin-left: -75px;
}

.phone.phone-left img {
  height: 100% !important;
}

.phone.phone-right {
  transform: translateY(19px);
}
</style>
<script>
import axios from "axios";
import Navbar from "../Layout/Navbar";
import FooterStyleFour from "../Layout/FooterStyleFour";
import Preloader from '../Layout/Preloader'
import { injectSchemaMarkup, generateWebSiteSchema, generateOrganizationSchema } from "../../utils/schemaUtils";
import meanderLogo from '../../assets/images/black-logo.png';
import { Search_APP, useGetNavMenuData } from '../../services/graphqlService';
import apolloClient from '../../apollo';
import { watchEffect } from 'vue';

export default {
  name: "TemplatesAndThemes",
  components: {
    Navbar,
    FooterStyleFour,
    Preloader
  },
  data() {
    return {
      relatedApps: [],
      appDATA: [],
      search: "",
      filteredApps: [],
      matchedPerson: [],
      slugToMatch: "",
      currentPage: 1,
      pageSize: 8, // Requested page size; adjust if needed
      total: 0,
      totalPages: 0, // Will be set based on the response
      loading: false,
      errorMessage: "",
      searchQuery: "", // New data property for search input
      showSearchResults: false, // New data property for search results dropdown
      hideSearchTimeout: null, // For search timeout management
    };
  },
  methods: {
    async getApp() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const response = await axios.get(
          `${this.$backendUrl}/api/apps?populate=*&pagination[page]=${this.currentPage}&pagination[pageSize]=${this.pageSize}`
        );
        console.log("Response Data:", response.data);

        this.appDATA = response.data;
        const { pagination } = response.data.meta;
        this.total = pagination.total;
        this.totalPages =
          pagination.pageCount || Math.ceil(this.total / this.pageSize);
      } catch (error) {
        console.error(error);
        this.errorMessage =
          "There was a problem loading the data. Please try again later.";
      } finally {
        this.loading = false;
      }
    },
    async searchApp(searchTerm) {
      this.loading = true;
      this.errorMessage = "";
      try {
        let url = `${this.$backendUrl}/api/apps?populate=screenshot_1`;
        if (searchTerm.trim()) {
          url += `&filters[$or][0][title][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
          url += `&filters[$or][1][name][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
          url += `&filters[$or][2][clone_synonyms][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
          url += `&filters[$or][3][alias_synonyms][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
          url += `&filters[$or][4][keywords][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
          url += `&filters[$or][5][description][$contains]=${encodeURIComponent(
            searchTerm
          )}`;
        }
        const response = await axios.get(url);
        this.appDATA = response.data;
        const { pagination } = response.data.meta;
        this.total = pagination.total;
        this.totalPages =
          pagination.pageCount || Math.ceil(this.total / this.pageSize);
      } catch (error) {
        console.error(error);
        this.errorMessage =
          "There was a problem loading the search results. Please try again later.";
      } finally {
        this.loading = false;
      }
    },
    changePage(page) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.currentPage = page;
      // Update the query parameter in the URL
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page },
      });
      // Fetch new data based on current search or default data
      if (this.search.trim()) {
        this.searchApp(this.search);
      } else {
        this.getApp();
      }
    },
    randomNumber() {
      return Math.floor(Math.random() * 100);
    },
    dateFormat(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    // Search functionality methods (from Navbar)
    async handleSearch() {
      clearTimeout(this.hideSearchTimeout); 
      if (this.searchQuery.trim() === '') {
        this.filteredApps = [];
        return;
      }
      const query = this.searchQuery.toLowerCase();
      const variables = {
        "filters": {
          "or": [
            {
              "clone_synonyms": {
                "containsi": query
              }
            },
            {
              "alias_synonyms": {
                "containsi": query
              }
            },
            {
              "keywords": {
                "containsi": query
              }
            },
            {
              "name": {
                "containsi": query
              }
            },
            {
              "description": {
                "containsi": query
              }
            },
          ]
        },
        pagination: { page: 1, pageSize: 100 }
      }
      const { data } = await apolloClient.query({
        query: Search_APP,
        variables
      })
      watchEffect(() => {
        this.filteredApps = data?.apps
      });
    },
    handleBlur() {
      // Delay hiding results to allow click events to fire
      setTimeout(() => {
        this.showSearchResults = false;
      }, 200);
    },
    navigateToApp(slug) {
      this.showSearchResults = false;
      this.searchQuery = '';
      this.$router.push(`/app-detail/${slug}`);
    },
  },
  watch: {
    // Watch the "page" query parameter in the URL
    "$route.query.page"(newPage) {
      const page = parseInt(newPage);
      if (!isNaN(page) && page > 0 && page !== this.currentPage) {
        this.currentPage = page;
        // Refetch data (respecting search if applicable)
        if (this.search.trim()) {
          this.searchApp(this.search);
        } else {
          this.getApp();
        }
      }
    },
  },
  async mounted() {
    // Check if there's a "page" query parameter in the URL and use it
    if (this.$route.query.page) {
      const page = parseInt(this.$route.query.page);
      if (!isNaN(page) && page > 0) {
        this.currentPage = page;
      }
    }
    await this.getApp();

    // Inject schema markup for SEO
    try {
      const schemas = [
        generateWebSiteSchema({
          name: "Meander Software - App Projects",
          description: "Explore our collection of professional app development projects and solutions"
        }),
        generateOrganizationSchema()
      ];
      injectSchemaMarkup(schemas);
    } catch (error) {
      console.error('Error injecting projects page schema:', error);
    }
  },
};

</script>